
















































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import IdDocType from '@/resources/enum/IdDocType';
import CameraPageShootCardAutoDriversLicenseFront from '@/components/CameraPageShootCardAutoDriversLicenseFront.vue';
import CameraPageShootCardAutoDriversLicenseDiagonal1 from '@/components/CameraPageShootCardAutoDriversLicenseDiagonal1.vue';
import CameraPageShootCardAutoDriversLicenseDiagonal2 from '@/components/CameraPageShootCardAutoDriversLicenseDiagonal2.vue';
import CameraPageShootCardAutoDriversLicenseBack from '@/components/CameraPageShootCardAutoDriversLicenseBack.vue';
import CameraPageShootCardAutoMyNumberCardFront from '@/components/CameraPageShootCardAutoMyNumberCardFront.vue';
import CameraPageShootCardAutoMyNumberCardDiagonal1 from '@/components/CameraPageShootCardAutoMyNumberCardDiagonal1.vue';
import CameraPageShootCardAutoMyNumberCardDiagonal2 from '@/components/CameraPageShootCardAutoMyNumberCardDiagonal2.vue';
import CameraPageShootCardDiagonalHeader from '@/components/CameraPageShootCardDiagonalHeader.vue';
import CameraPageShootMessageNormal from '@/components/CameraPageShootMessageNormal.vue';

@Component({
  components: {
    CameraPageShootCardAutoDriversLicenseFront,
    CameraPageShootCardAutoDriversLicenseDiagonal1,
    CameraPageShootCardAutoDriversLicenseDiagonal2,
    CameraPageShootCardAutoDriversLicenseBack,
    CameraPageShootCardAutoMyNumberCardFront,
    CameraPageShootCardAutoMyNumberCardDiagonal1,
    CameraPageShootCardAutoMyNumberCardDiagonal2,
    CameraPageShootCardDiagonalHeader,
    CameraPageShootMessageNormal
  }
})
export default class Parts extends Vue {
  private detectTimerId: number = -1;
  private timeoutTimerId: number = -1;
  private isTimeout: boolean = false;

  @Prop({ type: Number, required: true })
  public cardWidth!: number;

  @Emit('onDetect')
  private emitDetect() {}

  private get isIdDocFront(): boolean {
    return this.$store.state.camera.shootType === 'identity-document-front';
  }

  private get isIdDocDiagonal(): boolean {
    return this.$store.state.camera.shootType === 'identity-document-diagonal';
  }

  private get isIdDocBack(): boolean {
    return this.$store.state.camera.shootType === 'identity-document-back';
  }

  private get isIdDocDriversLicense(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.DriversLicenseHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.DriversLicenseTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.DriversLicenseTi) return true;
    if (this.$store.state.camera.idDocType === IdDocType.DrivingHistoryCertificateHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.DrivingHistoryCertificateTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.DrivingHistoryCertificateTi) return true;
    return false;
  }

  private get isIdDocMyNumberCard(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.MyNumberCardHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.MyNumberCardTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.MyNumberCardTi) return true;
    return false;
  }

  private get status(): 'none' | 'capture' | 'success' {
    if (this.isSuccess) return 'success';
    if (this.isCapture) return 'capture';
    return 'none';
  }

  private get isCapture(): boolean {
    return this.$store.state.camera.isDetectCapture;
  }

  private get isSuccess(): boolean {
    return this.$store.state.camera.isDetectSuccess;
  }

  private get svgSize(): { w: number; h: number } {
    if (this.isIdDocDriversLicense && this.isIdDocFront) return { w: 335, h: 210 };
    if (this.isIdDocDriversLicense && this.isIdDocDiagonal) return { w: 356, h: 140 };
    if (this.isIdDocDriversLicense && this.isIdDocBack) return { w: 335, h: 209 };
    if (this.isIdDocMyNumberCard && this.isIdDocFront) return { w: 335, h: 210 };
    if (this.isIdDocMyNumberCard && this.isIdDocDiagonal) return { w: 356, h: 140 };
    return { w: 0, h: 0 };
  }

  private get frameSize(): { x: number; y: number; w: number; h: number } {
    const w: number = this.cardWidth;
    const h: number = w * (this.svgSize.h / this.svgSize.w);
    const x: number = (this.$store.state.camera.displayWidth - w) / 2;
    const y: number = this.$store.state.camera.displayIdDocCenter - h / 2;
    return { x, y, w, h };
  }

  private get frameStyle(): { [key: string]: string } {
    return {
      left: `${this.frameSize.x}px`,
      top: `${this.frameSize.y}px`,
      width: `${this.frameSize.w}px`,
      height: `${this.frameSize.h}px`
    };
  }

  private get cardStyle(): { [key: string]: string } {
    const x: number = this.frameSize.x;
    const y: number = this.frameSize.y;
    const w: number = this.frameSize.w;
    const h: number = this.frameSize.h;
    const sx: number = w / this.svgSize.w;
    const sy: number = h / this.svgSize.h;
    const cx: number = x + w / 2;
    const isMirror: boolean = this.$store.getters['camera/isMirror'];
    return {
      transform: [
        `translateX(${cx}px) scaleX(${isMirror ? -1 : 1}) translateX(${-cx}px)`,
        `translate(${x}px, ${y}px) scale(${sx}, ${sy})`
      ].join(' ')
    };
  }

  private get warningMessages(): string[] {
    if (this.$store.state.camera.detectWarningCode && this.isTimeout) {
      const key: string = `componentsCameraPageShootCardAuto.${this.$store.state.camera.detectWarningCode}`;
      return (this.$t(key) as { [key: number]: string }) as string[];
    } else {
      return [];
    }
  }

  private get showCameraModeModal(): boolean {
    return this.$store.state.camera.showCameraModeModal;
  }

  private created(): void {
    this.$store.commit('camera/resetDetectCount');
    this.$store.commit('camera/isDetectCapture', false);
    this.$store.commit('camera/isDetectSuccess', false);
    this.$store.commit('camera/detectWarningCode', '');
  }

  private mounted(): void {
    this.detectTimerId = window.setTimeout(this.handleDetect, 500);
    this.timeoutTimerId = window.setTimeout((): void => {
      this.isTimeout = true;
    }, 3000);
  }

  private beforeDestroy(): void {
    window.clearTimeout(this.detectTimerId);
    window.clearTimeout(this.timeoutTimerId);
  }

  private handleDetect(): void {
    if (this.$store.state.camera.isDetectStop) return;
    // カメラモードの変更中はdetectを止める
    if (this.showCameraModeModal) return;
    if (!this.isSuccess) this.emitDetect();
    this.detectTimerId = window.setTimeout(this.handleDetect, 200);
  }

  @Watch('showCameraModeModal')
  private handleChangeShowingCameraModeModal() {
    // カメラモード変更のモーダルが閉じた時、Detectを再開する
    if (this.showCameraModeModal === false) {
      this.detectTimerId = window.setTimeout(this.handleDetect, 200);
    }
  }
}
